import { FC, useMemo } from "react";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { getTheme } from "Store/MultiDomain/MultiDomain.selector";
import {
  IContent,
  INotification,
  NotificationContentTypeEnum,
  NotificationSourceEnum,
} from "Data/interfaces/Notification/INotification";
import { objContent } from "./content";
import { Icon } from "Components/UI";
import SpinCustom from "Components/UI/SpinCustom";
import { GetAvatar } from "Utils/generateThumbnail";
import { formatDateNotificationDayjs } from "Utils/DateUtils";
import { processMessage } from "Utils/HtmlUtils";
import { loadImage } from "Utils/MultidomailUtils";
import { Wrapper, Container, LogoCoodly } from "./styles";

interface ICard {
  item: INotification;
  isPersonal?: boolean;
  readingNotificationId: string | null;
  isLoadingReadNotification: boolean;
  onRedirect: (item: INotification) => void;
  onMarkAsRead: (readRow: INotification) => void;
}

const Card: FC<ICard> = ({
  item,
  isPersonal,
  readingNotificationId,
  isLoadingReadNotification,
  onRedirect,
  onMarkAsRead
}) => {
  const theme = useSelector(getTheme);

  const contentFormated = useMemo(() => {
    const hasImgs = item.Content.some(content => {
      return content.Type === NotificationContentTypeEnum.images;
    });
    const firstIndex = item.Content.findIndex(content => {
      return content.Type === NotificationContentTypeEnum.ref;
    });
    if (
      !hasImgs &&
      firstIndex !== -1 &&
      item?.AggNotificationIds &&
      item.AggNotificationIds?.length > 0
    ) {
      item.Content[firstIndex].aggIds = item.AggNotificationIds;
    }
    return item.Content;
  }, [item]);

  return (
    <Wrapper>
      <Container onClick={() => onRedirect(item)}>
        <span className="leftContainer">
          {item.Source === NotificationSourceEnum.System && (
            <LogoCoodly
              src={loadImage('icon-logo-white.svg')}
              alt="Logo Coodly"
            />
          )}
          {item.Source === NotificationSourceEnum.User && (
            <GetAvatar
              name={item?.CreatedByUser?.Nome || ''}
              src={item?.CreatedByUser?.ThumbnailImageUrl || item?.CreatedByUser?.OriginalImageUrl || ''}
              size={24}
              fontSize={12}
            />
          )}
        </span>
        <span className="rightContainer">
          <span className="rightTextContainer">
            <span className="rightDescription">
              {processMessage(isPersonal ? item?.PersonalMessage || item.Message : item.Message)}
            </span>
            {contentFormated.map((contentItem: IContent) => (
              objContent[contentItem.Type]({
                content: contentItem.ContentItems,
                className: contentItem.Class,
                theme: theme.colors,
                aggIds: contentItem.aggIds,
              })
            ))}
            <span className="rightDate">
              {formatDateNotificationDayjs(dayjs(item.CreationDate))}
            </span>
          </span>
          <span className="rightActionButtons">
            <span
              className="rightActionButtonsRead"
              onClick={(e) => {
                e.stopPropagation();
                onMarkAsRead(item);
              }}
            >
              {readingNotificationId === item.NotificationId && isLoadingReadNotification ? (
                <SpinCustom
                  size={10}
                  color={theme.colors.surface.onSurfaceVariant}
                  marginRigth={4}
                />
              ) : (
                <Icon
                  icon="readNotification"
                  customSize={16}
                  className="iconReadNotification"
                />
              )}
            </span>
            <span className="badgeNewNotification" />
          </span>
        </span>
      </Container>
    </Wrapper>
  )
}

export default Card;
